import { Layout } from "@/components/Layout";
import { AgentView } from "@/components/AgentView";
import { useAuth } from "@/context/AuthContext";

export default function AgentDashboard() {
  const { user } = useAuth();
  return (
    <Layout>
      <AgentView title={`Ciao, ${user?.name?.split(" ")[0] || ""}`} subtitle="Ecco l'andamento dei tuoi premi." />
    </Layout>
  );
}
